/**
 * Application Version
 * Update this version number when deploying new changes
 * Format: MAJOR.MINOR.PATCH (e.g., 1.2.0)
 * 
 * Change Log:
 * - 1.0.0 (2026-05-21): Initial Audit Report feature release
 * - 1.0.1 (2026-05-21): Fix: Auto-add missing services to existing databases
 * - 1.0.2 (2026-05-21): Fix: PDF/Excel download now uses direct blob streaming
 * - 1.0.3 (2026-05-21): Fix: Download uses base64 data from generate response
 * - 1.0.4 (2026-05-21): Fix: CSV parsing with low_memory=False to prevent warnings
 */
export const APP_VERSION = '1.0.4';
export const APP_BUILD_DATE = '2026-05-21';
